export default __webpack_public_path__ + "images/Saravan_sanctuary.webp";